import moment from 'moment';
import { useState } from 'react';
import { TableInput } from '../../../../components/common';
import { TimePicker } from '@mui/x-date-pickers';
import DatePickerMui from '../../../../components/common/DatePickerMui';
import formatDate from '../../../../components/common/formatDate';
import { TableCompHead } from '../../../../components/ui';
import { convToTime } from '../../../../utils/helpers';
import CustomSelect from '../../../../components/common/SelectField';
import { MenuItem } from '@mui/material';

interface IProps {
  moduleData: any;
  tabValue: number;
  isView: boolean;
  // machineData?: any;
  // autoCompleteMachineValue?: any;
  // setAutoCompleteMachineValue?: any;
  setControllerRender: React.Dispatch<React.SetStateAction<boolean>>;
}

const THead = ({
  tabValue,
  moduleData,
  isView,
  // machineData,
  // autoCompleteMachineValue,
  // setAutoCompleteMachineValue,
  setControllerRender,
}: IProps) => {
  const [render, setRender] = useState(false);
  return (
    <thead>
      <TableCompHead
        colSpan={21 + 2}
        rowSpan={3}
        labels={['Doc No. ', 'Rev No. ', 'Date: ']}
        values={['FM/QA/10', '01', 'Aug 15']}
        heading="IN-PROCESS INSPECTION SHEET"
      />
      <tr>
        <th colSpan={21 + 2 - 2} align="left">
          Report Date:{' '}
          {isView ? (
            formatDate(moduleData.pir_date)
          ) : (
            <DatePickerMui
              label=""
              value={moment(moduleData.pir_date)}
              onChange={(date) => {
                moduleData.pir_date = date;
                setRender((prev) => !prev);
              }}
            />
          )}
        </th>
        <th colSpan={2}>
          SHIFT:
          {isView ? (
            moduleData.shift
          ) : (
            <CustomSelect
              name="shift"
              value={moduleData?.shift || ''}
              onChange={(e) => {
                moduleData.shift = e.target.value;
                setRender((prev) => !prev);
              }}
            >
              <MenuItem value="A">A</MenuItem>
              <MenuItem value="B">B</MenuItem>
            </CustomSelect>
          )}
        </th>
      </tr>
      <tr>
        <th colSpan={4} align="left">
          PART NAME:{' '}
          {moduleData.part_name
            ? moduleData.part_name
            : moduleData.part_id?.part_name}
        </th>
        <th colSpan={5} align="left">
          PART NUMBER:{' '}
          {moduleData.part_number
            ? moduleData.part_number
            : moduleData.part_id?.part_number}
        </th>
        <th colSpan={4}>
          MODEL:{' '}
          <TableInput
            name="model"
            type="text"
            value={moduleData.model}
            onChange={(e) => {
              moduleData.model = e.target.value;
              setRender((prev) => !prev);
            }}
            isView={isView}
          />
        </th>
        <th colSpan={8 + 2} align="left">
          CUSTOMER:{' '}
          {moduleData.customer_name
            ? moduleData.customer_name
            : moduleData.customer_id?.customer_name}
        </th>
      </tr>
      <tr>
        <th colSpan={4} align="left">
          OPERATION: {moduleData?.pirs?.[tabValue]?.process_name}
        </th>
        <th colSpan={17 + 2} align="left">
          Operation Date:{' '}
          {isView ? (
            formatDate(moduleData?.pirs?.[tabValue]?.operation_date)
          ) : (
            <DatePickerMui
              label=""
              value={moment(moduleData?.pirs?.[tabValue]?.operation_date)}
              onChange={(date) => {
                moduleData.pirs[tabValue].operation_date = date;
                setRender((prev) => !prev);
              }}
            />
          )}
          <span style={{ marginLeft: '300px' }}>TIME / OBSERVATION</span>
        </th>
      </tr>

      <tr style={{ textTransform: 'uppercase' }}>
        {[
          'S.NO.',
          'ITEM',
          'SPECIFICATION',
          'INSPECTION METHOD',
          // 'OBSERVATION',
        ].map((head) => (
          <th
            rowSpan={head === 'OBSERVATION' ? 1 : 2}
            colSpan={head === 'OBSERVATION' ? 10 : 1}
            style={{ textTransform: 'uppercase' }}
          >
            {head}
          </th>
        ))}
        {[1, 2, 3, 4, 5, 6, 7].map((head, timeHeadIdx) => (
          <>
            <th style={{ minWidth: '120px' }} colSpan={2}>
              {isView ? (
                convToTime(moduleData?.pirs?.[tabValue]?.times?.[timeHeadIdx])
              ) : (
                <TimePicker
                  ampm={false}
                  value={moment(
                    moduleData?.pirs?.[tabValue]?.times?.[timeHeadIdx] || '',
                  )}
                  onChange={(date: any) => {
                    moduleData.pirs[tabValue].times[timeHeadIdx] = date;
                    setRender((prev) => !prev);
                  }}
                />
              )}
            </th>
          </>
        ))}
        <th>JUDGEMENT</th>
        <th>NON CONFORMING CONSERVATION AND ACTION TAKEN (IF ANY)</th>
        <th>SIGNATURE(INSPECTOR)</th>
        <th colSpan={2}>REMARKS</th>
      </tr>
      {/* <tr>
        {Array.from({ length: 5 }, () => 0).map((_, index) => (
          <th key={'obs1' + index}>{index + 1}</th>
        ))}
        {Array.from({ length: 3 }, () => 0).map((_, index) => (
          <th key={'obs2' + index}> {index + 1}</th>
        ))}
        <th>Judgment (O/X)</th>
        <th>Remark</th>
      </tr> */}
    </thead>
  );
};

export default THead;
